import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, isDevMode, LOCALE_ID, NgModule, APP_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTimepickerModule } from '@angular/material/timepicker';

import { ApiService, AuthService, CacheService, InsightsService, LocalStorage, SettingsService, T4coreModule, TranslationService } from 't4core';

import { APP_BASE_HREF, registerLocaleData, CommonModule } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeNb from '@angular/common/locales/nb';
import localeNn from '@angular/common/locales/nn';
import localeSv from '@angular/common/locales/sv';
import localeAr from '@angular/common/locales/ar';
import localeIt from '@angular/common/locales/it';
import localeFr from '@angular/common/locales/fr';
import localeFi from '@angular/common/locales/fi';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AppComponentsModule, NavigationService, NavigationStep, BookingService } from 'app-components';
import { AppOnewayModule, OWAlternativeSelectorComponent, OWModelSelectorComponent } from 'app-oneway';
import { AppSettings, AppSettingsService, T4AppIntegrationModule } from 't4-app-integration';
import { BookingOptionComponent } from '../lib/Components/booking-option/booking-option.component';
import { PhoneFieldComponent } from '../lib/Components/form-phone-field/phone-field.component';
import { TextFieldComponent } from '../lib/Components/form-text-field/text-field.component';
import { InformationScreenComponent } from '../lib/Components/information-screen/information-screen.component';
import { LoadingScreenComponent } from '../lib/Components/loading-screen/loading-screen.component';
import { LocationMapComponent } from '../lib/Components/location-map/location-map.component';
import { LocationInformation } from '../lib/Components/LocationInformation/location-information.component';
import { MenuComponent } from '../lib/Components/menu/menu.component';
import { NewUserInfoComponent } from '../lib/Components/new-user-info/new-user-info.component';
import { ObjectInfoComponent } from '../lib/Components/object-info/object-info.component';
import { OnLoadComponent } from '../lib/Components/on-load/on-load.component';
import { PlaceSearchComponent } from '../lib/Components/place-search/place-search';
import { TimePicker } from '../lib/Components/timePicker/timePicker';
import { AppComponent } from './app.component';
import { BookingSummaryComponent } from './Booking/Components/booking-summary/booking-summary.component';
import { CategoryComponent } from './Booking/Components/category/category.component';
import { CustomerFormComponent } from './Booking/Components/customer-form/customer-form.component';
import { LocationComponent } from './Booking/Components/location/location.component';
import { CategorySelector } from './Booking/Components/trailer-categories/category-selector';
import { CreateBookingComponent } from './Booking/create-booking/create-booking.component';
import { AddonPopupComponent } from './Booking/dialogs/addon-popup/addon-popup.component';
import { FindLocationComponent } from './Booking/dialogs/find-location/find-location.component';
import { RentalAgreementComponent } from './Booking/dialogs/rental-agreement/rental-agreement.component';
import { ConfirmedBookingComponent } from './Booking/views/confirmed-booking/confirmed-booking.component';
import { DateAndTime } from './Booking/views/date-and-time/date-and-time';
import { InitiateNewBookigComponent } from './Booking/views/initiate-new-bookig/initiate-new-bookig.component';
import { PaymentComponent } from './Booking/views/payment/payment.component';
import { PickupLocationComponent } from './Booking/views/pickup-location/pickup-location';
import { ReturnLocationComponent } from './Booking/views/return-location/return-location';
import { SelectObject } from './Booking/views/select-object/select-object.component';
import { SetupCustomerComponent } from './Booking/views/setup-customer/setup-customer.component';
import { UnconfirmedBookingComponent } from './Booking/views/unconfirmed-booking/unconfirmed-booking.component';
import { HomeComponent } from './Home/Components/home/home.component';
import { OneWayHowToComponent } from './Home/Components/OneWayHowTo/OneWayHowTo.component';
import { OneWayStartComponent } from './Home/Components/OneWayStart/OneWayStart.component';
import { MonitorInterceptor } from './monitor.interceptor';
import { BookingOverviewComponent } from './MyPage/Components/booking-overview/booking-overview.component';
import { VerifyAccountComponent } from './MyPage/Components/verify-account/verify-account.component';
import { GPSDialogComponent } from './MyPage/Dialogs/gps-dialog/gps-dialog.component';
import { ImportBookingComponent } from './MyPage/Dialogs/import-booking/import-booking.component';
import { PinCodeDialog } from './MyPage/Dialogs/pin-code-dialog/pin-code-dialog';
import { MyBookingsComponent } from './MyPage/Views/my-bookings/my-bookings.component';
import { SettingsComponent } from './MyPage/Views/settings/settings.component';
import { SignInComponent } from './MyPage/Views/sign-in/sign-in.component';
import { PhotoViewComponent } from './Rental/Components/photo-view/photo-view.component';
import { RentalBoxComponent } from './Rental/Components/rental-box/rental-box.component';
import { LocationInfoComponent } from './Rental/dialogs/location-info/location-info.component';
import { TrailerInfoComponent } from './Rental/dialogs/trailer-info/trailer-info.component';
import { BookingInfoComponent } from './Rental/Views/booking-info/booking-info.component';
import { BookingUpdatedComponent } from './Rental/Views/booking-updated/booking-updated.component';
import { ConfirmLockComponent } from './Rental/Views/confirm-lock/confirm-lock.component';
import { DetectLockComponent } from './Rental/Views/detect-lock/detect-lock.component';
import { ExtendRentalComponent } from './Rental/Views/extend-rental/extend-rental.component';
import { InFlightComponent } from './Rental/Views/in-flight/in-flight.component';
import { LockTrailerComponent } from './Rental/Views/lock-trailer/lock-trailer.component';
import { PickupCompleteComponent } from './Rental/Views/pickup-complete/pickup-complete.component';
import { ReturnCompleteComponent } from './Rental/Views/return-complete/return-complete.component';
import { ReturnInfoComponent } from './Rental/Views/return-info/return-info.component';
import { ReturnPaymentComponent } from './Rental/Views/return-payment/return-payment.component';
import { SecurityCheckComponent } from './Rental/Views/security-check/security-check.component';
import { StartRentalComponent } from './Rental/Views/start-rental/start-rental.component';
import { StopRentalComponent } from './Rental/Views/stop-rental/stop-rental';
import { StowLockComponent } from './Rental/Views/stow-lock/stow-lock.component';
import { TakePicturesComponent } from './Rental/Views/take-pictures/take-pictures.component';
import { UnlockAfterCheckComponent } from './Rental/Views/unlock-after-check/unlock-after-check.component';
import { Use4FreeComponent } from './Home/Components/Use4Free/Use4Free';
import { ViewContentComponent } from '../lib/Components/view-content/view-content';
import { MatStepperModule } from '@angular/material/stepper';
import { ViewActionsComponent } from '../lib/Components/view-actions/view-actions';
import { AppCardComponent } from '../lib/Components/app-card/app-card';
import { BTPermissionRequiredComponent } from '../lib/InformationScreens/btPermissionRequired/btPermissionRequired';
import { LocationPermissionRequiredComponent } from '../lib/InformationScreens/locationPermissionRequired/locationPermissionRequired';
import { CameraPermissionRequired } from '../lib/InformationScreens/cameraPermissionRequired/cameraPermissionRequired';
import { SelectFamilyType } from './Booking/views/select-family-type/select-family-type';
import { ExtendRentalTimePickerComponent } from './Rental/Views/extend-rental-timePicker/extend-rental-timePicker';
import { SelectedObjectInfo } from './Booking/views/selected-object-info/selected-object-info';
import { ChatbotComponent } from '../lib/Components/chatbot/chatbot.component';
import { IdleDialog } from './MyPage/Dialogs/idle-dialog/idle-dialog';
import { NokeLockComponent } from './Rental/Views/noke-lock/noke-lock.component';
import { IglooLockComponent } from './Rental/Views/igloo-lock/igloo-lock.component';
import { NFCNoLockComponent } from './Rental/Views/nfc-nolock/nfc-nolock.component';
import { IdleTimerComponent } from '../lib/Components/idle-timer/idle-timer.component';
import { AppH1Component } from '../lib/Components/app-h1/app-h1';
import { TitleWithDividerComponent } from '../lib/Components/title-with-divider/title-with-divider';
import { AppIntegrationService } from 't4-app-integration';
import { NfcRequiredComponent } from '../lib/InformationScreens/nfcRequired/nfcRequired';
import { CampaignComponent } from './MyPage/Views/my-campaigns/my-campaigns';
import { CampaignDetailsComponent } from './MyPage/Views/campaign-details/campaign-details';
import { CampaignCardComponent } from './MyPage/Views/campaign-card/campaign-card';
import { DancingEnvelopeComponent } from './Rental/Components/dancing-envelope/dancing-envelope.component';
import { InviteFriendsComponent } from './Rental/Views/invite-friends/invite-friends.component';
import { CategoryListComponent } from '../lib/Components/category-list/category-list';
import { WebLandingPageComponent } from './Booking/views/web-landing-page/web-landing-page';
import { InviteFriendScreenComponent } from '../lib/Components/invite-friend-screen/invite-friend-screen.component';
import { NetworkStatusBannerComponent } from '../lib/Components/network-status-banner/network-status-banner.component';
import { CaptchaComponent } from './MyPage/Components/recaptcha-authentication/recaptcha-authentication.component';
import { SwapTrailerComponent } from './Booking/views/swap-trailer/swap-trailer';
import { SwapConfirmationDialog } from './Booking/dialogs/swap-confirmation/swap-confirmation';
import { LocationAccessDialog } from './Rental/dialogs/location-access/location-access';
import { LocationList } from './Booking/views/location-list/location-list.component';
import { AppSearchComponent } from '../lib/Components/app-search/app-search';
import { ReturnFarAwayDialog } from './Rental/dialogs/return-faraway/return-faraway';
import { ConfirmObjectDialog } from './Rental/dialogs/confirm-object/confirm-object';
import { OpenAppComponent } from './Home/Components/OpenApp/OpenApp';
import { ChooseSpecificTrailerComponent } from './Booking/views/choose-specific-trailer/choose-specific-trailer';
import { AnimatedCampaignCard } from '../lib/Components/animated-campaign-card/animated-campaign-card';
import { TravelRangeDialog } from './Booking/dialogs/travel-range/travel-range.component';
import { NuwielTrailerComponent } from './Rental/Views/nuwiel-trailer/nuwiel-trailer.component';
import { InstructionSliderComponent } from '../lib/Components/instruction-slider/instruction-slider.component';
import { ChangeBookingComponent } from './Booking/views/change-booking/change-booking';

// Routes
export const NavigationSteps: NavigationStep[] = [
  {
    Key: "Loading",
    Path: '**',
    AllowColdStart: true,
    Component: OnLoadComponent,
    Actions: []
  },
];

const LRM = '\u200E'; 
export class CustomDateAdapter extends NativeDateAdapter {
  // Override the method to set Monday as the first day of the week
  getFirstDayOfWeek(): number {
    return 1; // 1 = Monday, 0 = Sunday
  }

  override format(date: Date, displayFormat: any): string {
    if (displayFormat === 'input') {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${mm}${LRM}/${LRM}${dd}${LRM}/${LRM}${yyyy}`;
    }
    return super.format(date, displayFormat);
  }
}

export const APP_DATE_FORMATS = {
  parse: { dateInput: 'l' },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'long' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};

export const components: { [key: string]: any } = {
  AppComponent: AppComponent,
  HomeComponent: HomeComponent,
  BookingInfoComponent: BookingInfoComponent,
  DetectLockComponent: DetectLockComponent,
  StowLockComponent: StowLockComponent,
  CategorySelector: CategorySelector,
  TimePicker: TimePicker,
  DateAndTime: DateAndTime,
  LocationInformation: LocationInformation,
  SelectObject: SelectObject,
  SelectedObjectInfo: SelectedObjectInfo,
  SelectFamilyType: SelectFamilyType,
  ObjectInfoComponent: ObjectInfoComponent,
  InformationScreenComponent: InformationScreenComponent,
  SecurityCheckComponent: SecurityCheckComponent,
  TakePicturesComponent: TakePicturesComponent,
  BookingOptionComponent: BookingOptionComponent,
  SetupCustomerComponent: SetupCustomerComponent,
  UnconfirmedBookingComponent: UnconfirmedBookingComponent,
  BookingSummaryComponent: BookingSummaryComponent,
  PhotoViewComponent: PhotoViewComponent,
  PickupCompleteComponent: PickupCompleteComponent,
  InFlightComponent: InFlightComponent,
  LockTrailerComponent: LockTrailerComponent,
  ConfirmLockComponent: ConfirmLockComponent,
  ReturnCompleteComponent: ReturnCompleteComponent,
  ConfirmedBookingComponent: ConfirmedBookingComponent,
  PaymentComponent: PaymentComponent,
  BookingOverviewComponent: BookingOverviewComponent,
  FindLocationComponent: FindLocationComponent,
  ExtendRentalComponent: ExtendRentalComponent,
  ExtendRentalTimePickerComponent: ExtendRentalTimePickerComponent,
  MenuComponent: MenuComponent,
  SettingsComponent: SettingsComponent,
  LocationInfoComponent: LocationInfoComponent,
  TrailerInfoComponent: TrailerInfoComponent,
  VerifyAccountComponent: VerifyAccountComponent,
  NewUserInfoComponent: NewUserInfoComponent,
  RentalAgreementComponent: RentalAgreementComponent,
  AddonPopupComponent: AddonPopupComponent,
  OnLoadComponent: OnLoadComponent,
  ImportBookingComponent: ImportBookingComponent,
  IdleDialog: IdleDialog,
  ReturnInfoComponent: ReturnInfoComponent,
  GPSDialogComponent: GPSDialogComponent,
  UnlockAfterCheckComponent: UnlockAfterCheckComponent,
  InitiateNewBookigComponent: InitiateNewBookigComponent,
  SignInComponent: SignInComponent,
  BookingUpdatedComponent: BookingUpdatedComponent,
  MyBookingsComponent: MyBookingsComponent,
  CreateBookingComponent: CreateBookingComponent,
  StartRentalComponent: StartRentalComponent,
  StopRentalComponent: StopRentalComponent,
  ReturnPaymentComponent: ReturnPaymentComponent,
  ReturnLocationComponent: ReturnLocationComponent,
  PickupLocationComponent: PickupLocationComponent,
  OneWayStartComponent: OneWayStartComponent,
  OneWayHowToComponent: OneWayHowToComponent,
  OWModelSelectorComponent: OWModelSelectorComponent,
  OWAlternativeSelectorComponent: OWAlternativeSelectorComponent,
  Use4FreeComponent: Use4FreeComponent,
  ChatbotComponent: ChatbotComponent,
  NokeLockComponent: NokeLockComponent,
  IglooLockComponent: IglooLockComponent,
  NFCNoLockComponent: NFCNoLockComponent,
  WebLandingPageComponent: WebLandingPageComponent,
  CampaignCardComponent: CampaignCardComponent,
  CampaignComponent: CampaignComponent,
  CampaignDetailsComponent: CampaignDetailsComponent,
  DancingEnvelopeComponent: DancingEnvelopeComponent,
  InviteFriendsComponent: InviteFriendsComponent,
  InviteFriendScreenComponent: InviteFriendScreenComponent,
  NetworkStatusBannerComponent: NetworkStatusBannerComponent,
  CaptchaComponent: CaptchaComponent,
  SwapTrailerComponent: SwapTrailerComponent,
  SwapConfirmationDialog: SwapConfirmationDialog,
  LocationAccessDialog: LocationAccessDialog,
  LocationList: LocationList,
  AppSearchComponent: AppSearchComponent,
  ReturnFarAwayDialog: ReturnFarAwayDialog,
  OpenAppComponent: OpenAppComponent,
  ChooseSpecificTrailerComponent: ChooseSpecificTrailerComponent,
  ConfirmObjectDialog: ConfirmObjectDialog,
  AnimatedCampaignCard: AnimatedCampaignCard,
  TravelRangeDialog: TravelRangeDialog,
  NuwielTrailerComponent: NuwielTrailerComponent,
  InstructionSliderComponent: InstructionSliderComponent,
  ChangeBookingComponent: ChangeBookingComponent
}

// App initialization
export function initApp(
  settingsService: SettingsService,
  appSettings: AppSettingsService,
  api: ApiService,
  cache: CacheService,
  insights: InsightsService,
  bookingSvc: BookingService,
  navigation: NavigationService,
  translate: TranslationService,
  appSvc: AppIntegrationService) {
  return () => {
    // Load version and retrieve environment from server
    api.getVersion().then(x => {
      settingsService.appVersion = x.trim() + " - " + appSettings.appVersion;
    });

    // Initiate insights
    settingsService.appInsightsKey = '154faa6b-f843-4050-9c4f-d27ca633355f';
    settingsService.appName = appSettings.appType;
  



    insights.trackTrace("Starting application", { uri: document.location.href.toString() });
    
    if (isDevMode()) {
      //settingsService.setApiBase("https://api.turbo4.net/");
      //settingsService.ApiBase = "https://api.t4.brenderuprental.com/";
      //settingsService.setApiBase("https://api.t4.brenderuprental.com/");
      //settingsService.setApiBase("https://localhost:44310/");
      settingsService.setApiBase("https://api-test.turbo4.net/");
      //settingsService.setApiBase("https://localhost:44310/");

      //settingsService.setApiBase("https://api.turbo4.net/");
    }

    // Pre-load translations
    //var seed = appSettings.getContextParam("translations");
    //if (seed) translate.seed(seed);

    // Initialize
    appSettings.initApp().then(async (x) => {
      var task1 = bookingSvc.getLocations();
      var task2 = navigation.init();

      //var task3 = this.translate.load();
      await Promise.all([task1, task2]);
    });

    // Configure cache
    cache.context = appSettings.contextId;

    // Prepare navigation
    AppSettingsService.getComponents(components);

    api.setCancelOnNavigation(false);
    return true;
  };
}
// App initialization

// Register languages
registerLocaleData(localeSv);
registerLocaleData(localeDa);
registerLocaleData(localeNn);
registerLocaleData(localeNb);
registerLocaleData(localeDe);
registerLocaleData(localeAr);
registerLocaleData(localeIt);
registerLocaleData(localeFr);
registerLocaleData(localeFi);

@NgModule({ declarations: [
        LoadingScreenComponent,
        AppComponent,
        HomeComponent,
        BookingInfoComponent,
        DetectLockComponent,
        StowLockComponent,
        CategorySelector,
        TimePicker,
        DateAndTime,
        LocationInformation,
        BookingInfoComponent,
        SelectObject,
        SelectedObjectInfo,
        SelectFamilyType,
        ObjectInfoComponent,
        InformationScreenComponent,
        SecurityCheckComponent,
        TakePicturesComponent,
        BookingOptionComponent,
        SetupCustomerComponent,
        UnconfirmedBookingComponent,
        BookingSummaryComponent,
        PhotoViewComponent,
        PickupCompleteComponent,
        InFlightComponent,
        LockTrailerComponent,
        ConfirmLockComponent,
        ReturnCompleteComponent,
        ConfirmedBookingComponent,
        PaymentComponent,
        BookingOverviewComponent,
        FindLocationComponent,
        ExtendRentalComponent,
        ExtendRentalTimePickerComponent,
        MenuComponent,
        SettingsComponent,
        LocationInfoComponent,
        TrailerInfoComponent,
        VerifyAccountComponent,
        NewUserInfoComponent,
        RentalAgreementComponent,
        AddonPopupComponent,
        OnLoadComponent,
        ImportBookingComponent,
        IdleDialog,
        ReturnInfoComponent,
        GPSDialogComponent,
        PhoneFieldComponent,
        TextFieldComponent,
        UnlockAfterCheckComponent,
        MyBookingsComponent,
        CategoryComponent,
        LocationComponent,
        InitiateNewBookigComponent,
        CreateBookingComponent,
        SignInComponent,
        RentalBoxComponent,
        BookingUpdatedComponent,
        PlaceSearchComponent,
        StartRentalComponent,
        StopRentalComponent,
        PinCodeDialog,
        ReturnPaymentComponent,
        CustomerFormComponent,
        ReturnLocationComponent,
        LocationMapComponent,
        PickupLocationComponent,
        BTPermissionRequiredComponent,
        LocationPermissionRequiredComponent,
        CameraPermissionRequired,
        OneWayStartComponent,
        OneWayHowToComponent,
        Use4FreeComponent,
        ViewContentComponent,
        ViewActionsComponent,
        AppCardComponent,
        ChatbotComponent,
        NokeLockComponent,
        IglooLockComponent,
        NFCNoLockComponent,
        IdleTimerComponent,
        AppH1Component,
        NfcRequiredComponent,
        TitleWithDividerComponent,
        CampaignCardComponent,
        CampaignComponent,
        CampaignDetailsComponent,
        CategoryListComponent,
        DancingEnvelopeComponent,
        InviteFriendsComponent,
        WebLandingPageComponent,
        InviteFriendScreenComponent,
        NetworkStatusBannerComponent,
        CaptchaComponent,
        SwapTrailerComponent,
        SwapConfirmationDialog,
        LocationAccessDialog,
        LocationList,
        AppSearchComponent,
        LocationAccessDialog,
        ReturnFarAwayDialog,
        OpenAppComponent,
      ChooseSpecificTrailerComponent,
      ConfirmObjectDialog,
      AnimatedCampaignCard,
      TravelRangeDialog,
      NuwielTrailerComponent,
      InstructionSliderComponent,
      ChangeBookingComponent

    ],
    exports: [T4coreModule, MatSlideToggleModule, MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule, MatIconModule, MatTooltipModule, MatTabsModule, MatMenuModule, MatDialogModule, MatRadioModule, MatExpansionModule, MatSelectModule],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
        FormsModule,
        T4coreModule,
        AppComponentsModule,
        AppOnewayModule,
        MatStepperModule,
        T4AppIntegrationModule,
        RouterModule.forRoot(NavigationService.getRoutes(NavigationSteps), {
            scrollPositionRestoration: 'top'
        }),
        BrowserAnimationsModule,
        MatAutocompleteModule,
        GoogleMapsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatIconModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatDialogModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        MatDividerModule,
        MatRadioModule,
        MatButtonToggleModule,
    MatExpansionModule,
    MatTimepickerModule,
        MatSelectModule],
  providers: [
        { provide: APP_ID, useValue: 'ng-cli-universal' },
        {
            provide: APP_BASE_HREF, useFactory: () => { return window['baseUri'] ?? '/'; }
        },
        NavigationService,
        T4coreModule,
        {
            provide: APP_INITIALIZER, useFactory: initApp, deps: [SettingsService, AppSettingsService, ApiService, CacheService, InsightsService, BookingService, NavigationService, TranslationService, AppIntegrationService], multi: true
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: HTTP_INTERCEPTORS, useClass: MonitorInterceptor, multi: true },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        {
            provide: LOCALE_ID,
            useFactory: (settings: AppSettingsService) => {
                var language = settings.getLanguage();
                if (language == "no" || language == "nb")
                    return "nn";
                return language;
            },
            deps: [AppSettingsService]
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
